export default __webpack_public_path__ + "static/media/DAF2CDA4-53DC-4164-B3F5-A4C4100FA3F8.44392f72.jpeg";